export default __webpack_public_path__ + "static/Economic Model Whitepaper - Greek-96c457e67c510b217ddbdf523c337f79.pdf";